import { render, staticRenderFns } from "./datarmine.vue?vue&type=template&id=728de7ce&scoped=true"
import script from "./datarmine.vue?vue&type=script&lang=js"
export * from "./datarmine.vue?vue&type=script&lang=js"
import style0 from "./datarmine.vue?vue&type=style&index=0&id=728de7ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728de7ce",
  null
  
)

export default component.exports